// src/utils/imagePath.js

export const getImagePath = (path) => {
    // Remove leading slash if present
    const cleanPath = path.startsWith('/') ? path.substring(1) : path;

    // Use PUBLIC_URL from React (automatically uses homepage setting)
    const baseUrl = process.env.PUBLIC_URL || '';

    return `${baseUrl}/${cleanPath}`;
};

// Helper functions for specific image folders
export const getImage = {
    // Logo and brand images
    logo: () => getImagePath('images/logo.png'),

    // Company/Club images
    company: (filename) => getImagePath(`images/company/${filename}`),

    // Bars/Facilities images
    bars: (filename) => getImagePath(`images/bars/${filename}`),

    // Gallery images
    gallery: (filename) => getImagePath(`images/gallery/${filename}`),

    // Team images
    team: (filename) => getImagePath(`images/team/${filename}`),

    // Custom path

    // Custom path
    custom: (path) => getImagePath(path)
};